module.exports = __webpack_public_path__ + "img/img15.418c3c83.svg";